
import { Helper } from "../../utils/Helper";
import { BasicEngine } from "./BasicEngine"; 
import { IEngineCallbacks } from "./IEngine";
import { Linear, gsap } from "gsap";

export class ReelEngine extends BasicEngine {

    constructor(callbacks:IEngineCallbacks, target:PIXI.Container) {
        super(callbacks, target);
    }

    public Start(duration:number = 0, ease?:any):gsap.core.Timeline {
        this.nextTimeline = Helper.setTimeline(this.nextTimeline, new gsap.core.Timeline({ 
            paused:true,
            onStart:() => Helper.triggerIfExist(this.callbacks.onStartCallBack), 
            onComplete:() => Helper.triggerIfExist(this.callbacks.onCompletedStartCallback)
        }));

        this.nextTimeline.fromTo(this, {  yPos:0 }, {
            duration: duration,
            ease :   ease,
            yPos :   this.stepDistance
        });

        return this.nextTimeline;
    }

    public Step(stepDurr:number = 0):gsap.core.Timeline {
        this.nextTimeline = Helper.setTimeline( this.nextTimeline, new gsap.core.Timeline({ 
            paused:true,
            onRepeat : () => this.onStepCb(),
            repeat: -1,
            repeatDelay: 0,
        }));

        this.nextTimeline.fromTo(this, { yPos:0}, {
            duration: stepDurr,
            ease : "none",
            yPos : this.stepDistance,
        });

        return this.nextTimeline;
    }

    protected onStepCb():void{
        Helper.triggerIfExist( this.callbacks.onCompletedStepCallback );
    }
    
    public Stop(duration:number = 0, ease?:any):gsap.core.Timeline {

        this.nextTimeline = Helper.setTimeline( this.nextTimeline, new gsap.core.Timeline({
            paused:true,
            onComplete:() =>  this.onSpinStopCompleted()
        }));

        this.nextTimeline.to(this , { duration:duration,
            ease : ease,
            yPos : 0,
        });

        this.nextTimeline.add(() => Helper.triggerIfExist(this.callbacks.onStopCallback), duration*0.75);
        this.nextTimeline.add(() => this.onBounce(),duration*0.75);

        return this.nextTimeline;
    }

    public Idle():gsap.core.Timeline {
        this.nextTimeline = Helper.setTimeline(this.nextTimeline, new gsap.core.Timeline());
        return this.nextTimeline;
    }

    protected onBounce():void {
        Helper.triggerIfExist(this.callbacks.onBounceStartCallback);
    }

    protected onSpinStopCompleted():void {
        this.yPos = 0;
        Helper.triggerIfExist(this.callbacks.onCompletedStopCallback);
    }

    protected onNudgeCompleted():void {
        this.yPos = 0;
        Helper.triggerIfExist(this.callbacks.onCompletedNudgeCallback);
    }

    protected onNudged():void {
        this.yPos = 0;
        Helper.triggerIfExist(this.callbacks.onNudgedCallback);
    }

    public Nudge(repeat:number = 0, duration:number = 0.5, ease?:any, stepDistance?:number, onNudgedCallback: () => void = () => {}):gsap.core.Timeline {
        this.nextTimeline = new gsap.core.Timeline({ 
            paused:true,
            repeat: repeat,
            onRepeat:() => {this.activeTimeline?.invalidate()},
            onComplete : () => this.onNudgeCompleted()
        });

        const dist:number = stepDistance != undefined ? stepDistance : this.stepDistance;

        this.nextTimeline.to(this, {
            duration:duration, 
            ease : ease,
            yPos : "+=" + dist,
        });

        this.nextTimeline.add(() => {
            this.onNudged();
            onNudgedCallback();
        });

        return this.nextTimeline;
    }
}